export default __webpack_public_path__ + "static/media/ML.85009856.jpeg";